export interface ElectricalConfiguration {
  voltage?: number;
  frequency?: number;
  powerFactor?: number;
  calibrationFactor?: number;
  nominalCurrent?: number;
  phaseType?: string;
  sensorType?: string;
  primary?: string;
  secondary?: string;
}

export interface ElectricalConfigurationInput {
  voltage?: number;
  frequency?: number;
  powerFactor?: number;
  calibrationFactor?: number;
  nominalCurrent?: number;
  phaseType?: string;
  sensorType?: string;
  primary?: string;
  secondary?: string;
}

export interface UpdateElectricalConfigurationInput {
  positionIds: string[];
  electricalConfig: ElectricalConfigurationInput;
}

export interface PositionWithElectricalConfig {
  positionId: string;
  positionName: string;
  positionType?: string;
  electricalConfig?: ElectricalConfiguration;
  hasActiveMeter?: boolean;
}

// Enums for dropdown options
export enum PhaseType {
  SINGLE_PHASE = "1P",
  THREE_PHASE = "3P",
}

// Legacy enum values for backward compatibility
export const PhaseTypeLegacy = {
  SINGLE_PHASE: "single_phase",
  THREE_PHASE: "three_phase",
} as const;

export enum SensorType {
  CT = "ct",
  ROGOWSKI = "rogowski",
  HALL_EFFECT = "hall_effect",
  VOLTAGE_DIVIDER = "voltage_divider",
}

export enum FrequencyStandard {
  FREQ_50HZ = 50,
  FREQ_60HZ = 60,
}

export enum VoltageLevel {
  // Single-phase voltages (used for individual stream measurements)
  V_110 = 110,
  V_120 = 120,
  V_220 = 220,
  V_230 = 230,
  V_240 = 240,
}

// CT Clamp current ratings
export enum CTClampRating {
  CLAMP_20A = 20,
  CLAMP_30A = 30,
  CLAMP_100A = 100,
  CLAMP_500A = 500,
  CLAMP_800A = 800,
  CLAMP_1000A = 1000,
}

// CT Clamp types from existing system
export interface CTClampType {
  value: number;
  label: string;
  maxCurrent: number;
  description?: string;
}

export const CT_CLAMP_TYPES: CTClampType[] = [
  { value: 2, label: "White CT Clamp 20A", maxCurrent: 20 },
  { value: 1, label: "Blue CT Clamp 20A", maxCurrent: 20 },
  { value: 0, label: "Blue CT Clamp 100A", maxCurrent: 100 },
  { value: 5, label: "White CT clamp KCT10 30A", maxCurrent: 30 },
  { value: 6, label: "ASCT-500A", maxCurrent: 500 },
  { value: 7, label: "ASCT-800A", maxCurrent: 800 },
  { value: 8, label: "ASCT-1000A", maxCurrent: 1000 },
];
